import { useContext } from 'react';

import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';

const FamilyPlanHeader = ({ box }) => {
  const { user } = useContext(UserContext);
  const hasSmsDiscount = user?.smsDiscount && box?.smsIncentivePromo;

  return (
    <>
      <Text brandStylesOverrides="h7 text-secondary" className="m-0 uppercase">
        {box?.promoApplied && hasSmsDiscount
          ? `${box?.promo.displayedDiscount} + 5% SMS DISCOUNT`
          : box?.promoApplied
            ? `${box?.promo.displayedDiscount} this box`
            : hasSmsDiscount
              ? '5% SMS DISCOUNT APPLIED'
              : 'FAMILY MENU'}
      </Text>
      {box?.promoApplied ? (
        <Text htmlElement="span">
          <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
            {box?.promo.subtotalFormatted}
          </Text>
          <Text htmlElement="span" className="font-medium text-charcoal-80 line-through">
            {box?.subtotalFormatted}
          </Text>
        </Text>
      ) : hasSmsDiscount ? (
        <Text htmlElement="span">
          <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
            {box?.smsIncentivePromo.subtotalFormatted}
          </Text>
          <Text htmlElement="span" className="font-medium text-charcoal-80 line-through">
            {box?.subtotalFormatted}
          </Text>
        </Text>
      ) : (
        <Text brandStylesOverrides="h2 text-primary">{box?.subtotalFormatted} / Serving</Text>
      )}
    </>
  );
};

FamilyPlanHeader.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    promo: PropTypes.shape({
      subtotalFormatted: PropTypes.string,
      pricePerServingFormatted: PropTypes.string,
      displayedDiscount: PropTypes.string,
    }),
    subtotalFormatted: PropTypes.string,
    smsIncentivePromo: PropTypes.shape({
      subtotalCents: PropTypes.number,
      subtotalFormatted: PropTypes.string,
    }),
  }).isRequired,
};

export default FamilyPlanHeader;
